import React, { Component } from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";

import { toggleApplyPopup, toggleBathroomVisualizerOpen, addToCart } from "../../actions/actionFunctions";
import Quantity from "../ui/quantity";
import {getCurrentLayout} from '../appLayout';
import {FormattedMessage, injectIntl} from "react-intl";

import {browserIsSafari, featureThumbnailUrl} from "../../misc/helpers";
import Analytics from './../../analytics';
import FeatureName from "../visComponents/featureName";

class ApplyPopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeApplyPopupItems: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (Array.isArray(nextProps.activeApplyPopupItems) && nextProps.activeApplyPopupItems.length) {
      let filteredActiveApplyPopupItems = [];
      // console.log(' nextProps.activeApplyPopupItems',  nextProps.activeApplyPopupItems);
      nextProps.activeApplyPopupItems.forEach((activeApplyPopupItem) => {
        let allreadyExist = false;
        if (activeApplyPopupItem.cartFeature.isStoneFeature) {
          const exisingIndex = filteredActiveApplyPopupItems.findIndex((filteredActiveApplyPopupItem) => {
            return filteredActiveApplyPopupItem.cartFeature.partName === activeApplyPopupItem.cartFeature.partName
          });
          if (activeApplyPopupItem.selectionGroup === "Vanity" && activeApplyPopupItem.cartFeature.dbFeature.displayName.includes('VanityAccent')) {
            const existingWallIndex = nextProps.activeApplyPopupItems.findIndex((nextActiveApplyPopupItem) => {
              return nextActiveApplyPopupItem.cartFeature.partName === activeApplyPopupItem.cartFeature.partName
            });
            if (existingWallIndex !== -1) { // no wall with current name
              allreadyExist = true;
            }
          } else if (exisingIndex > -1) {
            allreadyExist = true;
          }
        }
        if (!allreadyExist) {
          const existInCart = nextProps.cartItems.find(cartItem => cartItem.partId === activeApplyPopupItem.partId);
          filteredActiveApplyPopupItems.push({
            ...activeApplyPopupItem,
            quantity: existInCart ? existInCart.quantity : activeApplyPopupItem.quantity
          });
        }
      });
      // console.log('filteredActiveApplyPopupItems', filteredActiveApplyPopupItems);
      this.setState({
        activeApplyPopupItems: filteredActiveApplyPopupItems
      })
    }
    if (nextProps.applyPopupOpened && !this.props.applyPopupOpened) {
      document.body.classList.add('body--apply-popup');
    }
  }

  handleChangeItemQuantity = (quantity, cartItemIndex) => {
    this.setState({
      activeApplyPopupItems: this.state.activeApplyPopupItems.map((applyPopupItem, applyPopupItemIndex) => {
        if (applyPopupItemIndex === +cartItemIndex) {
          applyPopupItem.quantity = quantity;
        }
        return applyPopupItem
      })
    });
  };

  handleApplyPopupToggle = () => {
    Analytics.sendClickEvent('apply-popup-toggle');
    this.props.toggleApplyPopup(false);
    document.body.classList.remove('body--apply-popup');
  };

  handleApply = (applyCartItems) => {
    const layout = getCurrentLayout();
    Analytics.sendClickEvent('apply-popup-apply-' + (applyCartItems ? 'yes': 'no'));
    this.handleApplyPopupToggle();
    document.body.classList.add('body--materials');
    if (!window.location.href.includes('shoppingcart')) {
      hashHistory.push('shoppingcart');
    }
    this.props.toggleBathroomVisualizerOpen(false);
    if (applyCartItems) {
      this.props.addToCart(this.state.activeApplyPopupItems);
    }
    layout.updateLocalStorage();
  };

  getFeaturesList = () => {
    // console.log(this.state.activeApplyPopupItems);
    const {intl} = this.props;
    return this.state.activeApplyPopupItems.map((cartItem, index) => {
      const unit = cartItem.cartFeature.dbFeature.unit || intl.formatMessage({id: "quotingTool.featureInfo.defaultQuantity"});
      return (
        <li className="apply-popup-item" key={cartItem.cartFeature.partName+index}>
          <div className="table">
            <div className="apply-popup-item__image">
              <img src={cartItem.thumbnail || featureThumbnailUrl(cartItem.cartFeature)} alt={cartItem.cartFeature.partName}/>
            </div>
            <div className="apply-popup-item__main">
              <h4 className="apply-popup-item__main-title bold">
                <FeatureName feature={cartItem.cartFeature}/>
              </h4>
              <p className="apply-popup-item__main-description" dangerouslySetInnerHTML={{
                __html: cartItem.description || cartItem.cartFeature.dbFeature.displayName
              }} />
            </div>
            {cartItem.cartFeature.dbFeature.hideQuantity ? null :
            <div className="apply-popup-item__quantity">
              <Quantity size="normal" value={cartItem.quantity} title={unit}
                        changeValue={value => this.handleChangeItemQuantity(value, index)}/>
            </div>}
          </div>
          {cartItem.quantity <= 0 ? (
            <p className="apply-popup-item__no-quantity"><FormattedMessage id="applyFeaturesPopup.noQuantity"/>
              <FormattedMessage id="applyFeaturesPopup.noQuantity2"/></p>
          ) : null}
        </li>
      )
    })
  };

  render() {

    const popupStyles = browserIsSafari() && (this.props.windowWidth > 480) && (this.props.windowWidth <= 991) ? { height: this.props.windowHeight - 10 } : {};

    return this.props.applyPopupOpened ? (
      <div className="overlay" style={popupStyles}>
        <div className="apply-popup">
          <div className="apply-popup-header">
            <h3 className="apply-popup-header__title bold"><FormattedMessage id="applyFeaturesPopup.title"/></h3>
            <button className="apply-popup-header__close ui-close" onClick={this.handleApplyPopupToggle}/>
          </div>
          <div className="apply-popup-body">
            <ul className="apply-popup-list">
              {this.getFeaturesList()}
            </ul>
          </div>
          <div className="apply-popup-footer">
            <button className="ui-button3 ui-button3--blue" onClick={() => this.handleApply(false)}>
              <FormattedMessage id="applyFeaturesPopup.viewCartButton"/>
            </button>
            <button className="ui-button3 ui-button3--green" onClick={() => this.handleApply(true)}>
              <FormattedMessage id="applyFeaturesPopup.applyButton"/>
            </button>
          </div>
        </div>
      </div>
    ) : null
  }
}

const mapStateToProps = (store) => {
  return {
    applyPopupOpened: store.cartState.applyPopupOpened,
    activeApplyPopupItems: store.cartState.activeApplyPopupItems,
    windowWidth: store.serverState.windowWidth,
    windowHeight: store.serverState.windowHeight,
    cartItems: store.cartState.cartItems,
  };
};

const mapDispatchToProps = {
  toggleApplyPopup,
  toggleBathroomVisualizerOpen,
  addToCart
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ApplyPopup)
)
